/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

export * from "./comment.defs.js";
export { main as default } from "./comment.defs.js";
